// ── Kanban Color Palette ─────────────────────────────────────────────
// All color tokens used across the Kanban page.
// Theme-aware values reference CSS variables from index.css (:root / [data-theme="dark"]).
// Accent / stage / status colors are brand colors — identical across themes.

// ── Stage Colors ────────────────────────────────────────────────────
export const STAGE_COLORS = {
  backlog: "#64748b",
  sourcing: "#6366f1",
  po_issued: "#f59e0b",
  supplier_confirmed: "#a78bfa",
  inventory_ready: "#06b6d4",
  in_transit: "#3b82f6",
  receiving: "#8b5cf6",
  in_stock: "#10b981",
  fulfillment: "#f97316",
  delivered: "#22c55e",
  pending_delivery: "#fbbf24",
};

// ── Priority Colors ─────────────────────────────────────────────────
export const PRIORITY_COLORS = {
  critical: { text: "#ef4444", bg: "#fef2f2" },
  high: { text: "#f97316", bg: "#fff7ed" },
  medium: { text: "#f59e0b", bg: "#fffbeb" },
  low: { text: "#64748b", bg: "#f8fafc" },
};

// ── Status Colors ───────────────────────────────────────────────────
export const STATUS_COLORS = {
  on_track: "#10b981",
  at_risk: "#f59e0b",
  blocked: "#ef4444",
};

// ── Surface / Background Colors (theme-aware) ───────────────────────
export const SURFACE = {
  pageBg: "var(--dashboard-bg)",
  navBg: "var(--bg-appbar)",
  metricStripBg: "var(--bg-secondary)",
  cardBg: "var(--bg-paper)",
  cardBgDefault: "var(--bg-paper)",
  cardBlockedBg: "var(--bg-error-highlight)",
  panelBg: "var(--bg-paper)",
  barBg: "var(--bg-input)",
  hoverBg: "var(--hover-bg)",
  columnHeaderBg: "var(--bg-appbar)",
  wipBarBg: "var(--bg-input)",
  primaryBg: "var(--bg-primary)",
};

// ── Border Colors (theme-aware) ─────────────────────────────────────
export const BORDER = {
  subtle: "var(--border-color)",
  dark: "var(--border-color-subtle)",
  navBottom: "var(--border-color)",
  metricDivider: "var(--border-color-subtle)",
  statusBar: "var(--border-color-subtle)",
};

// ── Text Colors (theme-aware) ───────────────────────────────────────
export const TEXT = {
  primary: "var(--text-primary)",
  secondary: "var(--text-secondary)",
  tertiary: "var(--text-tertiary)",
  muted: "var(--text-secondary)",
  dim: "var(--text-secondary)",
  darkest: "var(--border-color-subtle)",
  heading: "var(--text-heading)",
  link: "var(--text-link)",
};

// ── Accent & Misc ───────────────────────────────────────────────────
export const ACCENT = {
  indigo: "#6366f1",
  indigoLight: "#818cf8",
  green: "#10b981",
  greenBright: "#22c55e",
  amber: "#f59e0b",
  orange: "#f97316",
  red: "#ef4444",
  redLight: "#fca5a5",
  blue: "#3b82f6",
  purple: "#a78bfa",
};

// ── Category chart palette (cycles) ─────────────────────────────────
export const CATEGORY_PALETTE = [
  "#6366f1",
  "#10b981",
  "#f59e0b",
  "#3b82f6",
  "#f97316",
  "#a78bfa",
  "#22c55e",
];
